var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"message":_vm.errors,"type":{ 'is-danger': _vm.errors ? _vm.errors.length : false }}},[_c('b-autocomplete',{attrs:{"data":_vm.filteredOpts,"field":_vm.field,"open-on-focus":"","clearable":"","disabled":_vm.disabled,"required":false,"loading":_vm.options.length < 1,"placeholder":_vm.placeholder},on:{"select":(opt) => {
        _vm.$emit('input', opt ? opt.id : null);
      }},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }